import {metlJobApi, type MetlJobApi} from "./MetlJobApi";
import {listEndpoint, type ListEndpoint} from "./util/ListEndpoint";
import type {AxiosInstance} from "axios";
import type {MetlJobExport} from "../metl-models/exports/MetlJobExport.ts";
import type {MetlVersionDebug} from "../metl-models/debug/MetlVersionDebug.ts";

export interface MetlVersionApi {
    jobs: ListEndpoint<MetlJobApi, MetlJobExport>
    debug: () => Promise<MetlVersionDebug>
}

export function metlVersionApi(axios: AxiosInstance, baseUrl: string, id: string): MetlVersionApi {
    return {
        jobs: listEndpoint(axios, `${baseUrl}/job`, `${id}/job`, metlJobApi),
        debug: async () => await axios.get<MetlVersionDebug>(`${baseUrl}/debug`).then(r => r.data)
    }
}